import axios from "axios";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../api-urls";

// Function to get Auth Token
const getAuthToken = () => {
  const token = localStorage.getItem("authToken");
  console.log("Auth Token:", token); // Debugging
  return token ? `Bearer ${token}` : null;
};

// Fetch Cart Items
export const fetchCartItems = async() => {
  try {
    const token = getAuthToken();
    if (!token) throw new Error("Unauthorized: No auth token");

    console.log("Fetching cart items...");
    const response = await axios.get(API_ENDPOINTS.cart, { headers: { Authorization: token } });
    console.log("Cart items fetched:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching cart items:", error);
    return error;
  }
}
// export const fetchCartItems = createAsyncThunk("cart/fetchCartItems", async (_, { rejectWithValue }) => {
//   try {
//     const token = getAuthToken();
//     if (!token) throw new Error("Unauthorized: No auth token");

//     console.log("Fetching cart items...");
//     const response = await axios.get(API_ENDPOINTS.cart, { headers: { Authorization: token } });
//     console.log("Cart items fetched:", response.data);
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching cart items:", error);
//     return rejectWithValue(error.message);
//   }
// });

// Add Item to Cart
export const addToCart = createAsyncThunk(
  "cart/addToCart",
  async ({ clickedItem, selectedSize, quantity = 1 }, { dispatch, rejectWithValue }) => {
    try {
      console.log("🛒 Adding to cart:", { clickedItem, selectedSize, quantity });

      const token = getAuthToken();
      if (!token) throw new Error("Unauthorized: No auth token");

      const product = clickedItem?.data;
      if (!product?.selectedVariant?.id) {
        console.error("❌ Missing selectedVariant ID!", product);
        return rejectWithValue("Variant ID is required");
      }

      const payload = {
        product,
        selectedVariant: product.selectedVariant,
        product_id: Number(product.selectedVariant.id),
        color: product.color || "Red",
        variant_id: Number(product.selectedVariant.id),
        quantity: Number(quantity) || 1,
        size: selectedSize,
        image: product.selectedVariant.main_image,
        price: product.selectedVariant.price,
        discount_price: product.selectedVariant.discount_price,
      };

      console.log("📩 Sending payload to API:", payload);
      const response = await axios.post(API_ENDPOINTS.cart, payload, {
        headers: { Authorization: token },
      });

      console.log("✅ Add to cart success:", response.data);
      dispatch(openCart()); // Open cart when an item is added
      return response.data;
    } catch (error) {
      console.error("❌ API Error:", error.response?.data || error.message);
      return rejectWithValue(error.response?.data || "Failed to add item");
    }
  }
);

// Remove Item from Cart
export const removeFromCart = createAsyncThunk("cart/removeFromCart", async ({ product_id, selectedSize }, { dispatch, rejectWithValue }) => {
  try {
    console.log("🗑 Removing item from cart:", { product_id, selectedSize });
    const token = getAuthToken();
    if (!token) throw new Error("Unauthorized: No auth token");

    const response = await axios.delete(API_ENDPOINTS.cart, {
      headers: { Authorization: token },
      data: { product_id, selectedSize },
    });

    console.log("✅ Item removed from cart:", response.data);
    if (response.status === 200) dispatch(fetchCartItems());
    return response.data;
  } catch (error) {
    console.error("❌ Error removing cart item:", error);
    return rejectWithValue(error.message);
  }
});

// Cart Slice
const cartSlice = createSlice({
  name: "cart",
  initialState: { cartItems: [], loading: false, error: null, isCartOpen: false },
  reducers: {
    clearCart: (state) => {
      state.cartItems = [];
      console.log("🛒 Cart cleared");
    },
    openCart: (state) => {
      state.isCartOpen = true;
      console.log("🛒 Cart slider opened");
    },
    closeCart: (state) => {
      state.isCartOpen = false;
      console.log("🛒 Cart slider closed");
    },
  },
  extraReducers: (builder) => {
    builder
      // .addCase(fetchCartItems.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      //   console.log("⏳ Fetching cart items...");
      // })
      // .addCase(fetchCartItems.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.cartItems = action.payload;
      //   console.log("✅ Cart items fetched successfully");
      // })
      // .addCase(fetchCartItems.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.payload;
      // })
      .addCase(addToCart.pending, (state) => {
        state.loading = true;
      })
      .addCase(addToCart.fulfilled, (state, action) => {
        state.loading = false;
        state.cartItems.push(action.payload);
        console.log("✅ Item added to cart in state");
      })
      .addCase(addToCart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(removeFromCart.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeFromCart.fulfilled, (state) => {
        state.loading = false;
        console.log("✅ Cart item removed in state");
      })
      .addCase(removeFromCart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCart, openCart, closeCart } = cartSlice.actions;
export default cartSlice.reducer;
